/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon24Solid = forwardRef('ArrowDUturnUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.276.806a1.5 1.5 0 1 0-2.052 2.188L16.43 6H10.5a8.5 8.5 0 0 0 0 17h6a1.5 1.5 0 0 0 0-3h-6a5.5 5.5 0 1 1 0-11h5.983l-3.259 3.056a1.5 1.5 0 1 0 2.052 2.188l4.833-4.53a3 3 0 0 0 0-4.378L15.276.806Z" })));
});
